import { auctionConfigInitialState } from '../auction-config/form/initial-states';
import { releaseInfoInitialState } from '../release-info/form/initial-states';
import { splitsInitialState } from '../splits/form/initial-states';
import type { UploadToolPersistState, UploadToolState } from './schema';

export function uploadToolInitialState() {
  return {
    id: '',
    artistId: '',
    currentStep: null,
    isFirstStep: false,
    isLastStep: false,
    isProcessing: false,
    isSaving: false,
    lastCompletedStep: 1,
    releaseInfo: releaseInfoInitialState(),
    splits: splitsInitialState(),
    auctionConfig: auctionConfigInitialState(),
    transaction: null,
    releaseId: null,
    expectedContractAddress: null,
    gelatoTaskId: null,
  } satisfies UploadToolState;
}

export function uploadToolInitialPersistState() {
  return {
    id: '',
    artistId: '',
    currentStep: null,
    isFirstStep: false,
    isLastStep: false,
    isProcessing: false,
    isSaving: false,
    lastCompletedStep: 1,
    releaseInfo: {
      fields: releaseInfoInitialState().fields,
    },
    splits: {
      fields: splitsInitialState().fields,
    },
    auctionConfig: {
      fields: auctionConfigInitialState().fields,
      hasPresaleMint: false,
      hasGAEdition: true,
    },
    transaction: null,
    releaseId: null,
    expectedContractAddress: null,
    gelatoTaskId: null,
  } satisfies UploadToolPersistState;
}
